module.exports = {
  "en_US": [
    {
      "name": "Limited",
      "order": 1,
      "short_code": "a",
      "sub_meta": [
        {
          "name": "Consumption Voucher",
          "order": 1,
          "short_code": "a1",
          "sub_meta": [
            {
              "name": "AlipayHK",
              "order": 1,
              "short_code": "a11",
            },
            {
              "name": "Octopus",
              "order": 2,
              "short_code": "a12",
            },
            {
              "name": "Tap & Go",
              "order": 3,
              "short_code": "a13",
            },
            {
              "name": "WeChat Pay HK",
              "order": 4,
              "short_code": "a14",
            }
          ],
        },
        {
          "name": "Artist",
          "order": 2,
          "short_code": "a2",
          "sub_meta": [
            {
              "name": "Mirror",
              "order": 1,
              "short_code": "a21",
            },
            {
              "name": "Error",
              "order": 2,
              "short_code": "a22",
            },
          ],
        },
      ]
    },
    {
      "name": "Care",
      "order": 2,
      "short_code": "b",
      "sub_meta": [
        {
          "name": "Handicapped",
          "order": 1,
          "short_code": "b1"
        },
        {
          "name": "Special Needs",
          "order": 2,
          "short_code": "b2"
        },
        {
          "name": "Long-term Patients",
          "order": 3,
          "short_code": "b3"
        },
        {
          "name": "Pregnant Woman",
          "order": 4,
          "short_code": "b4"
        },
      ]
    },
    {
      "name": "Gender",
      "order": 3,
      "short_code": "c",
      "sub_meta": [
        {
          "name": "Male",
          "order": 1,
          "short_code": "c1"
        },
        {
          "name": "Female",
          "order": 2,
          "short_code": "c2"
        },
      ]
    },
    {
      "name": "Age",
      "order": 4,
      "short_code": "d",
      "sub_meta": [
        {
          "name": "Newborn (0-5 week)",
          "order": 1,
          "short_code": "d1"
        },
        {
          "name": "Infant (5 week to 1 yrs)",
          "order": 2,
          "short_code": "d2"
        },
        {
          "name": "Toddler (1 ~ 3 yrs)",
          "order": 3,
          "short_code": "d3"
        },
        {
          "name": "Child (4 ~ 11 yrs)",
          "order": 4,
          "short_code": "d4"
        },
        {
          "name": "Junior (12 ~ 17 yrs)",
          "order": 5,
          "short_code": "d5"
        },
        {
          "name": "Youth (18 ~ 29 yrs)",
          "order": 6,
          "short_code": "d6"
        },
        {
          "name": "Young Adult (30 ~ 44 yrs)",
          "order": 7,
          "short_code": "d7"
        },
        {
          "name": "Middle  (45 ~ 59 yrs)",
          "order": 8,
          "short_code": "d8"
        },
        {
          "name": "Elderly (> 60 yrs)",
          "order": 9,
          "short_code": "d9"
        }
      ]
    },
  ],
  "zh_HK": [
    {
      "name": "限定",
      "order": 1,
      "short_code": "a",
      "sub_meta": [
        {
          "name": "消費卷",
          "order": 1,
          "short_code": "a1",
          "sub_meta": [
            {
              "name": "支付寶香港",
              "order": 1,
              "short_code": "a11",
            },
            {
              "name": "八達通",
              "order": 2,
              "short_code": "a12",
            },
            {
              "name": "Tap & Go",
              "order": 3,
              "short_code": "a13",
            },
            {
              "name": "微信支付香港版",
              "order": 4,
              "short_code": "a14",
            }
          ],
        },
        {
          "name": "藝人",
          "order": 2,
          "short_code": "a2",
          "sub_meta": [
            {
              "name": "Mirror",
              "order": 1,
              "short_code": "a21",
            },
            {
              "name": "Error",
              "order": 2,
              "short_code": "a22",
            },
          ],
        },
      ]
    },
    {
      "name": "關愛",
      "order": 2,
      "short_code": "b",
      "sub_meta": [
        {
          "name": "傷殘人士",
          "order": 1,
          "short_code": "b1"
        },
        {
          "name": "特殊需要",
          "order": 2,
          "short_code": "b2"
        },
        {
          "name": "長期患者",
          "order": 3,
          "short_code": "b3"
        },
        {
          "name": "孕婦",
          "order": 4,
          "short_code": "b4"
        },
      ]
    },
    {
      "name": "性別",
      "order": 3,
      "short_code": "c",
      "sub_meta": [
        {
          "name": "男",
          "order": 1,
          "short_code": "c1"
        },
        {
          "name": "女",
          "order": 2,
          "short_code": "c2"
        },
      ]
    },
    {
      "name": "年齡",
      "order": 4,
      "short_code": "d",
      "sub_meta": [
        {
          "name": "新生兒 (0-5週)",
          "order": 1,
          "short_code": "d1"
        },
        {
          "name": "嬰兒 (5週〜1歲)",
          "order": 2,
          "short_code": "d2"
        },
        {
          "name": "幼兒 (1 ~ 3歲)",
          "order": 3,
          "short_code": "d3"
        },
        {
          "name": "兒童 (4 ~ 11歲)",
          "order": 4,
          "short_code": "d4"
        },
        {
          "name": "少年 (12 ~ 17歲)",
          "order": 5,
          "short_code": "d5"
        },
        {
          "name": "青年 (18 ~ 29歲)",
          "order": 6,
          "short_code": "d6"
        },
        {
          "name": "青壯年 (30 ~ 44歲)",
          "order": 7,
          "short_code": "d7"
        },
        {
          "name": "中年 (45 ~ 59歲)",
          "order": 8,
          "short_code": "d8"
        },
        {
          "name": "長者 (> 60歲)",
          "order": 9,
          "short_code": "d9"
        }
      ]
    },
  ]
}